function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.625 0a5.63 5.63 0 015.625 5.625 5.62 5.62 0 01-.793 2.882l-4.352 7.265a.469.469 0 01-.8.006L.84 8.583A5.607 5.607 0 010 5.625 5.63 5.63 0 015.625 0zm0 .931A4.704 4.704 0 00.931 5.625c0 .873.248 1.725.705 2.464l4.06 6.542 3.956-6.605a4.684 4.684 0 00.664-2.401A4.701 4.701 0 005.625.931zm0 1.881a2.817 2.817 0 012.813 2.813 2.808 2.808 0 01-2.813 2.813 2.81 2.81 0 01-2.813-2.813 2.817 2.817 0 012.813-2.813zm0 .932a1.887 1.887 0 00-1.881 1.881 1.879 1.879 0 103.759 0 1.885 1.885 0 00-1.878-1.881z",
  fill: "#333",
  fillRule: "nonzero"
});

function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _ref);
}

export default SvgLocation;